import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

export default createReducer({}, {

    [actions.UPDATE_BOUNDS]: (state, action) => action.bounds

})


// WEBPACK FOOTER //
// ./src/reducers/mapBounds.js